export default "__VITE_ASSET__DsMBkDW0__"